import React from 'react'
import { Link } from 'react-router-dom';
import styles from './WhatPersonal.module.css'
import commonStyles from "../../Shared/commonStyles.module.css";
import { GiCandleLight, GiBeachBag  } from "react-icons/gi";
import { FaShoppingBasket,FaTag  } from "react-icons/fa";

function WhatPersonal() {

    const personalisationOptions = [
        {
            title:"Hamper Contents",
            description:"Choose from a wide range of products to create a hamper that suits the recipient's tastes and preferences.",
            icon: <FaShoppingBasket className={styles.BasketIcon} />
            // icon: <BasketIcon className={styles.BasketIcon} />
        },
        {
            title:"Clothing & Bags with Embroidery",
            description:"Personalised embroidery on bags, clothing, aprons, teddies, blankets, and more."  ,
            // icon: <BagIcon className={styles.BagIcon} />
            icon: <GiBeachBag className={styles.BagIcon} />
        },
        {
            title:"Candles & Bottle Buckets with Vinyl Lettering",
            description:"Add names or designs using vinyl lettering on Bottle Buckets, Candles, Scrapbooks, and Clothes Hangers.",
            icon: <GiCandleLight className={styles.CandleIcon} />
            //<CandleIcon className={styles.CandleIcon} />
        },
        {
            title:"Gift Tag Messages",
            description:(
                <>
                    Add a handwritten message. See{' '}
                    <Link to="/customer-services/Giftwrap" className={commonStyles.btnLink}>Gift Wrap</Link>{' '}
                    for more details.
                </>
            ),
            icon: <FaTag className={styles.TagIcon} />
            // icon: <TagIcon className={styles.TagIcon} />
        }
    ];




  return (
    <div className={`${commonStyles.card} ${styles.WhatPersonal}`}>
        <h3>WHAT YOU CAN PERSONALISE</h3>
        <div className={commonStyles.cards4}>            
            {personalisationOptions.map((option, index) => (
                <div key={index} className={`${styles.PersonalisationOption} ${commonStyles.card}`}>
                    <h4>{option.title}</h4>
                    {option.icon}
                    <p>{option.description}</p>
                </div>
            ))}
        </div>
    </div>
    
  )
}


export default WhatPersonal